import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const AiAssistantPage = lazy(() =>
  import('@repo/ui/features/ai/assistant').then((mod) => ({ default: mod.AiAssistantPage })),
);

export default function AiAssistantRoute() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement de l'assistant IA..." />}>
      <AiAssistantPage />
    </Suspense>
  );
}
